import React, { FunctionComponent, ReactNode } from 'react'

export type ThemeProps = 'light' | 'dark'

type Props = {
  theme: ThemeProps
  children: ReactNode
}

/**
 * Component for rendering child components with a theme specific styles
 * @component
 * @example
 * const theme = 'light'
 * return (
 *   <ThemedContainer theme={theme}>{children}<ThemedContainer/>
 * )
 */
export const ThemedContainer: FunctionComponent<Props> = ({ theme, children }: Props) => (
  <div data-theme={theme}>{children}</div>
)
